import { useSelector } from "react-redux";
import { getEffectivePermissions } from "../config/pagePermissions";

const useSpecialActions = () => {
  const user = useSelector((state) => state.auth.user);
  const roles = useSelector((state) => state.permissions.roles);
  return (
    Number(user?.role) === 1 ||
    getEffectivePermissions(user, roles).includes("specialActions")
  );
};

export default useSpecialActions;
